import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { MapPin, BedDouble, Bath, Ruler } from "lucide-react";

export default function PropertyCard({ p, index = 0 }) {
  return (
    <motion.div
      data-testid={`property-card-${p.property_id}`}
      initial={{ opacity: 0, y: 16 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4, delay: index * 0.05, ease: [0.2, 0.7, 0.2, 1] }}
    >
      <Link to={`/property/${p.property_id}`} className="prop-card hairline bg-white overflow-hidden block cursor-pointer">
      <div className="aspect-[4/3] overflow-hidden bg-[var(--paper-2)]">
        {p.images?.[0] ? (
          <img src={p.images[0]} alt={p.title} className="w-full h-full object-cover" />
        ) : (
          <div className="w-full h-full grid place-items-center text-xs uppercase tracking-[0.2em] text-muted-foreground">no image</div>
        )}
      </div>
      <div className="p-5">
        <div className="flex items-center gap-1 text-[10px] tracking-[0.25em] uppercase text-muted-foreground mb-2">
          <MapPin className="w-3 h-3" strokeWidth={1.75} />
          <span>{p.city}, {p.country}</span>
        </div>
        <h3 className="font-display text-xl font-medium leading-tight mb-1">{p.title}</h3>
        <p className="text-sm text-muted-foreground line-clamp-2 mb-4">{p.description}</p>
        <div className="flex items-center justify-between">
          <div className="font-display text-2xl font-semibold tabular-nums">
            {(() => {
              try {
                return new Intl.NumberFormat("en", { style: "currency", currency: p.currency || "EUR", maximumFractionDigits: 0, currencyDisplay: "narrowSymbol" }).format(p.price);
              } catch {
                return `${p.currency || "EUR"} ${Number(p.price).toLocaleString()}`;
              }
            })()}
          </div>
          <div className="flex items-center gap-3 text-xs text-muted-foreground">
            {p.bedrooms > 0 && <span className="flex items-center gap-1"><BedDouble className="w-3.5 h-3.5" strokeWidth={1.75} />{p.bedrooms}</span>}
            {p.bathrooms > 0 && <span className="flex items-center gap-1"><Bath className="w-3.5 h-3.5" strokeWidth={1.75} />{p.bathrooms}</span>}
            {p.area_sqm > 0 && <span className="flex items-center gap-1"><Ruler className="w-3.5 h-3.5" strokeWidth={1.75} />{p.area_sqm}m²</span>}
          </div>
        </div>
      </div>
      </Link>
    </motion.div>
  );
}
